// components/NewChatDialog.js
import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    Button,
} from '@chakra-ui/react';
import { useRef } from 'react';

export default function NewChatDialog({ isOpen, onClose, onConfirm }) {
    const cancelRef = useRef();

    return (
        <AlertDialog
            isOpen={isOpen}
            leastDestructiveRef={cancelRef}
            onClose={onClose}
            isCentered
        >
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize="lg" fontWeight="600">
                        Start New Chat
                    </AlertDialogHeader>

                    <AlertDialogBody>
                        Your current chat will be lost. Do you want to proceed?
                    </AlertDialogBody>

                    <AlertDialogFooter>
                        <Button ref={cancelRef} onClick={onClose}
                            bg="#FFFFFF"
                            color="#037A9B"
                            border="1px solid #00C2E5"
                            borderRadius="12px"
                            fontWeight="600"
                            _hover={{
                                bg: '#ffffff',
                                color: '#CF008A',
                                borderColor: '#FF9CEE',
                                '& .review-icon': {
                                    backgroundImage: "url('/icon_btn_pink.svg')"
                                }
                            }}
                            _active={{ bg: '#FFFFFF' }}
                        >
                            No
                        </Button>

                        <Button
                            onClick={onConfirm} ml={3}
                            bg="#CF008A"
                            color="#FFFFFF"
                            borderRadius="12px"
                            _hover={{ bg: "#D933A1" }}
                            _active={{ bg: "#CF008A" }}
                        >
                            Yes
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    );
}
